import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateLinkMutation } from "../graphql/mutations";
import type {
  UpdateLinkMutationType,
  UpdateLinkMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateLinkMutation = (
  options?: MutationHookOptions<
    UpdateLinkMutationType,
    UpdateLinkMutationVariablesType
  >
) => {
  return useMutation<UpdateLinkMutationType, UpdateLinkMutationVariablesType>(
    UpdateLinkMutation,
    options
  );
};
